import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DateAdapter } from '@angular/material/core';
import { AbstractStorageService, Language } from '@libs/index';
import { LOCALIZATION_LOCALE } from '@libs/index';
import { AbstractI18nService } from '@libs/index';
import languageLoaderHelper from './language-loader-helper';
import { SUPPORTED_LANGUAGE } from '../../models/consts/Language.const';

@Injectable({
  providedIn: 'root',
})
export class I18nService extends AbstractI18nService {
  constructor(
    protected translateService: TranslateService,
    protected storageService: AbstractStorageService,
    protected matDateAdapter: DateAdapter<any>
  ) {
    super(translateService, storageService, matDateAdapter);

    // Embed languages to avoid extra HTTP requests
    this.translateService.setTranslation(
      LOCALIZATION_LOCALE.CZ,
      languageLoaderHelper.getCzLanguageSet()
    );
    this.translateService.setTranslation(
      LOCALIZATION_LOCALE.DE,
      languageLoaderHelper.getDeLanguageSet()
    );
    this.translateService.setTranslation(
      LOCALIZATION_LOCALE.FR,
      languageLoaderHelper.getFrLanguageSet()
    );
    this.translateService.setTranslation(
      LOCALIZATION_LOCALE.US,
      languageLoaderHelper.getUsLanguageSet()
    );
    this.translateService.setTranslation(
      LOCALIZATION_LOCALE.VN,
      languageLoaderHelper.getVnLanguageSet()
    );
  }

  public override getSupportedLanguage(): Language[] {
    return SUPPORTED_LANGUAGE;
  }
}
